import React from "react";
import PrivacyPolicy from "components/privacy-policy/PrivacyPolicy";
import Header from "components/headers/lp-header";
import Footer from "components/footers/lp-footer";

export default () => {
  return (
    <>
      <Header />
      <div className="content-container">
      <PrivacyPolicy />
      </div>
      <Footer />
    </>
  );
};
